import { css } from '@emotion/core';
import { MediaQueries } from '../../../../styles/Grid';

export const containerSizesShop = {
  background: '#EEF0F2',
  [MediaQueries.sm]: {
    paddingBottom: '0px',
    paddingTop: '0px',
  },
};

export const getHighlightTxt = txtColor =>
  css({
    'h2 span': {
      color: txtColor,
    },
  });

export const itemsBoxCss = css({
  '.findoutlink': {
    color: '#E52500',
    marginTop: '40px',
    position: 'absolute',
    bottom: '40px',

    [MediaQueries.sm]: {
      display: 'inline-grid',
      position: 'relative',
      bottom: 'auto',
    },

    a: {
      color: '#E52500',
      textDecoration: 'none',
      marginRight: '15px',
      fontSize: '18px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '32px',
      textAlign: 'left',
      [MediaQueries.sm]: {
        fontSize: '16px',
      },
      [MediaQueries.md]: {
        fontSize: '16px',
      },

      'span:first-child': {
        borderBottom: '#fad3cc solid 1px',
        paddingBottom: '5px',
      },

      [MediaQueries.md]: {
        marginBottom: '24px',
        marginRight: '0px',
        fontSize: '16px',
        lineHeight: '24PX',
      },

      [MediaQueries.sm]: {
        marginBottom: '24px',
        marginRight: '0px',
        fontSize: '16px',
        lineHeight: '24PX',
      },
      i: {
        paddingLeft: '15px',
        position: 'relative',
        top: '3px',
        paddingRight: '15px',
      },
    },
  },
});

export const itemsContainerCss = css({
  paddingBottom: '0px',
  paddingTop: '0px',

  [MediaQueries.sm]: {
    paddingBottom: '0px',
    paddingTop: '0px',
  },

  '.booknowflex': {
    display: 'flex',
    '.findoutlink': {
      marginRight: '16px',
    },
  },

  '.mdsection': {
    width: '100%',
    borderRadius: '16px',
    paddingTop: '9px',
    paddingBottom: '9px',
    marginLeft: '0px',
    marginRight: '0px',
    [MediaQueries.sm]: {
      width: 'auto',
      paddingTop: '0px',
      paddingBottom: '0px',
    },

    '.sec1:last-child': {
      h2: {
        span: {
          // color: '#33A2A4',
        },
      },
    },

    '.sec1': {
      display: 'flex',
      [MediaQueries.sm]: {},
    },
  },
});
